export var VaultDisplayServiceEvent;
(function (VaultDisplayServiceEvent) {
    VaultDisplayServiceEvent["VaultDisplayOptionsChanged"] = "VaultDisplayOptionsChanged";
})(VaultDisplayServiceEvent || (VaultDisplayServiceEvent = {}));
